export default {
  namespaced: true,
  state: {
    /**
     * Controller name - referece to API point
     */
    controller: "",
    /**
     * Keeps track of wether things were loaded
     *
     * @type { Boolean }
     */
    loader: {
      list: false,
      details: false
    },
    /**
     * List of rows
     *
     * @type { Array }
     */
    list: [],
    /**
     * Pagination object - based of laravel output
     *
     * @type { Boolean }
     */
    pagination: {},
    /**
     *
     */
    filters: {
      page: 1,
      search: ""
    },
    /**
     * Stores details of a selected row
     *
     * @type { Object }
     */
    details: {}
  },
  getters: {},
  mutations: {
    /**
     * Set controller for API calls
     *
     * @param { string } controller
     */
    SET_CONTROLLER: (state, controller) => {
      if (state.controller !== controller) {
        state.controller = controller
        state.filters.search = ""
        state.filters.page = 1
      }
    },
    /**
     * Writes provided list of documents to the state and
     * sets the listLoaded flag to true
     *
     * @param { Array } list - List of documents
     */
    SET_LIST: (state, value) => {
      state.list = value
      state.loader.list = false
    },
    /**
     * Clears list of documents
     */
    CLEAR_LIST: (state) => {
      state.list = []
      state.loader.list = false
    },
    /**
     * Writes details of selected document to the state
     *
     * @param { Object } document - document details
     */
    SET_DETAILS: (state, document) => {
      state.details = document
      state.loader.details = false
    },
    /**
     * Clears document details
     */
    CLEAR_DETAILS: (state) => {
      state.details = {}
      state.loader.details = false
    },
    /**
     * Writes current pagination params to the state
     *
     * @param { Object } pagination - Latest pagination settings
     */
    SET_PAGINATION: (state, value) => {
      state.pagination.current_page = value.current_page
      state.pagination.last_page = value.last_page
      state.pagination.per_page = 5
      state.pagination.total = value.total || 0
      state.pagination.from = value.from || 0
      state.pagination.to = value.to || 0

      state.filters.page = 1
    }
  },
  actions: {
    /**
     * Set controller actions
     */
    setController: async ({ commit }, params) => {
      commit("SET_CONTROLLER", params)
    },
    /**
     * Retrieves list of documents from api
     * commits mutations to write the list and pagination params to state
     *
     * @param { Object } params - Filtering, sorting and pagination parameters
     *
     * @return { Object } If there are no errors return response status
     * @return { Object } If there are errors return the error response
     */
    getList: async ({ commit, state }, params) => {
      if (params && params.controller) {
        commit("SET_CONTROLLER", params.controller)
        delete params.controller
      }

      try {
        let promise = await window.axios.get(state.controller, { params: {
          ...state.filters,
          ...params
        } })
        if (promise.data.data) {
          commit("SET_LIST", promise.data.data)
          commit("SET_PAGINATION", promise.data)
        } else {
          commit("SET_LIST", promise.data)
        }
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    /**
     * Commits the mutation that clears the list
     */
    clearList: async ({ commit }) => {
      commit("CLEAR_LIST")
      commit("SET_PAGINATION", {})
    },
    /**
     * Retrieves document details from api
     * commits mutations to write the details to state
     *
     * @param { Number } id - Id of the document we want to get details for
     *
     * @return { Object } If there are no errors return response status
     * @return { Object } If there are errors return the error response
     */
    getDetails: async ({ commit, state }, { id, params, controller }) => {
      if (controller) {
        commit("SET_CONTROLLER", controller)
      }

      try {
        let promise = await window.axios.get(state.controller + "/" + id, { params })
        commit("SET_DETAILS", promise.data)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    /**
     * Commits the mutation that clears the details object
     */
    clearDetails: async ({ commit }) => {
      commit("CLEAR_DETAILS")
    },
    /**
     * Creates a new document record from provided params
     *
     * @param { Object } params - document info to be stored
     *
     * @return { Object } If there are no errors return response status
     * @return { Object } If there are errors return the error response
     */
    store: async ({ dispatch, state }, params) => {
      if (params.id > 0) {
        let id = params.id
        delete params.id

        return dispatch("update", { id, params })
      }

      try {
        let promise = await window.axios.post(state.controller, params)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    /**
     * Updates a document record with provided params
     *
     * @param { Number } id - Id of the document we wish to update
     * @param { Object } params - Params we wish to update the record with
     *
     * @return { Object } If there are no errors return response status
     * @return { Object } If there are errors return the error response
     */
    update: async ({ state }, { id, params }) => {
      try {
        let promise = await window.axios.put(state.controller + "/" + id, params)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    /**
     * Deletes a document record
     *
     * @param { Number } id - Id pf the document record we wish to delete
     *
     * @return { Object } If there are no errors return response status
     * @return { Object } If there are errors return the error response
     */
    delete: async ({ state }, id) => {
      try {
        let promise = await window.axios.delete(state.controller + "/" + id)
        return { status: promise.status }
      } catch (error) {
        return { ...error.response }
      }
    },
    /**
     * Updates a document record with provided params
     *
     * @param { Number } id - Id of the document we wish to update
     * @param { Object } params - Params we wish to update the record with
     *
     * @return { Object } If there are no errors return response status
     * @return { Object } If there are errors return the error response
     */
    request: async ({ state }, options) => {
      try {
        let promise = await window.axios(options)
        return promise
      } catch (error) {
        return { ...error.response }
      }
    }
  }
}
